module.exports = __webpack_public_path__ + "static/media/icons-guest-infant.43e3cdf5.svg";